import { motion } from "framer-motion";

const B = "https://customer-assets-wrfwihn1.emergentagent.net/job_asilo-peramore/artifacts/";
const imgs = [
  B + "q3k5su82_06573af1-c34e-4581-8eea-c14ed5e206b1.jpeg",
  B + "za71iy8d_7bc227d8-5460-4bc1-b354-5726c79aee69.jpeg",
  B + "p0ndjoff_8d8eff0e-9790-4f1b-ac83-611e9484e22c.jpeg",
  B + "gvdl5uve_c139798f-6ca1-4075-abc5-38163d780484.jpeg",
  B + "3a3peiq0_f985e2cd-c1c3-4219-a77d-a1dce70636e8.jpeg",
  B + "zuzbt9rk_1920cc2a-f212-4dc5-ac6c-8b15e7b7e24d.jpeg",
];

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="py-20 sm:py-28 scroll-mt-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <p className="text-sm font-800 uppercase tracking-[0.2em] text-fuchsia-500">Gallery</p>
        <h2 className="mt-2 font-heading text-3xl sm:text-4xl md:text-5xl font-700 text-slate-800">Il mondo dei vostri bambini</h2>
        <p className="mt-4 max-w-2xl mx-auto text-slate-600 font-600 text-base sm:text-lg">
          Qui i bambini cantano, colorano, pitturano, manipolano, giocano con puzzle e incastri e vivono ogni giorno una nuova avventura.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-5">
        {imgs.map((src, i) => (
          <motion.div
            key={i}
            data-testid={`gallery-img-${i}`}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            className="overflow-hidden rounded-2xl group"
          >
            <img src={src} alt={`Gallery ${i + 1}`} className={`w-full object-cover group-hover:scale-105 transition-transform duration-500 ${i % 5 === 0 ? "h-56 sm:h-72" : "h-44 sm:h-60"}`} />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
